import { RegistrationPreset } from '~/models'
import { ResourceFormModel } from '~/ui/resources/form'

export default class AllowedProjectsFormModel extends ResourceFormModel<RegistrationPreset> {

}